<template>
  <div class="promo-code">
    <label for="promo-code" class="control-label">Have a promo code?</label>

    <div class="form-item inline-fields">
      <input
        v-model="promoCode"
        name="promo-code"
        placeholder="Promo Code"
        @keyup.enter="applyPromoCode()"
      />
      <a class="button-outlined" @click="applyPromoCode()">Apply</a>
    </div>
    <div class="form-item promo-code-result">
      <p
        v-for="promoCode in filteredPromoCodes"
        :key="promoCode.toLowerCase().split(' ').join('-')"
      >
        Using Code: {{ promoCode.toUpperCase() }} -
        <a @click.prevent="removePromoCode(promoCode)">
          <span class="badge badge-info vue-anchor">X</span>
        </a>
      </p>

      <span v-if="promoErrorMessage">
        {{ promoErrorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
  import { useCartStore } from '~/stores/cart';

  export default {
    setup() {
      const cartStore = useCartStore();
      return { cartStore };
    },
    data: () => ({
      promoCode: '',
      promoErrorMessage: '',
    }),
    computed: {
      filteredPromoCodes() {
        return this.cartStore.promoCodes.filter(
          (promoCode) => !promoCode.toLowerCase().includes('prorate')
        );
      },
    },
    methods: {
      async applyPromoCode() {
        this.promoErrorMessage = '';
        if (!this.promoCode) return;

        try {
          await this.cartStore.applyPromo(this.promoCode);
        } catch (error) {
          this.promoErrorMessage = error.message;
        }
      },
      async removePromoCode(promoCode) {
        this.promoErrorMessage = '';

        try {
          await this.cartStore.removePromo(promoCode);
        } catch (error) {
          if (error.response?.data?.message) {
            this.promoErrorMessage = error.response.data.message;
            return;
          }
          this.promoErrorMessage = 'Failed to remove promo code.';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .promo-code {
    margin-bottom: 50px;

    .inline-fields {
      margin-bottom: 10px;
    }

    .promo-code-result {
      margin-bottom: 0;
      font-size: 14px;
      font-style: italic;
      p {
        margin-top: 5px;
      }
    }
  }
</style>
